import React, {
  useCallback, useContext, useState
} from 'react';
import { useNavigate } from 'react-router-dom';

import { ButtonBar, ScreenHeader } from '../../components';
import { useScrollToTop } from '../../hooks';

import { NewPOAContext } from './new-poa-composer';

export function NewPOAGiftsToOthers() {
  const { powerOfAttorney, setPowerOfAttorney } = useContext(NewPOAContext);
  const navigate = useNavigate();
  const [ giftsToOthers, setGiftsToOthers ] = useState(powerOfAttorney.gifts_to_others || 'none');
  
  useScrollToTop();
  
  const handleBack = useCallback(() => {
    navigate('../gifts-to-agent');
  }, [ navigate ]);

  const handleNext = useCallback(() => {
    setPowerOfAttorney(prev => ({ 
      ...prev, 
      gifts_to_others: giftsToOthers
    }));
    
    navigate('../gift-recipients');
  }, [ giftsToOthers, setPowerOfAttorney, navigate ]);
  
  return (
    <div className="new-poa-gifts-to-others screen-container screen">
      <ScreenHeader
        title="Gifts to Other People"
        description="Decide whether to authorize your agent to make gifts to other people"
        handleBack={handleBack}
      />
      
      <div className="content-section">
        <h3>Authorizing Gifts to Others</h3>
        <p>
          You can authorize your agent to make gifts to other people or organizations. 
          This might include:
        </p>
        <ul className="gift-examples">
          <li>Family members and loved ones</li>
          <li>Charitable organizations</li>
          <li>Friends and close relationships</li>
          <li>Annual gift tax exclusion planning</li>
          <li>Educational or medical expenses</li>
        </ul>

        <h3>What Level of Gift Authorization Do You Want?</h3>
        <div className="gift-authorization">
          <div className="gift-option">
            <label className="gift-label">
              <input
                type="radio"
                name="gifts-to-others"
                value="none"
                checked={giftsToOthers === 'none'}
                onChange={(e) => setGiftsToOthers(e.target.value)}
              />
              <div className="gift-content">
                <h4>No Gifts to Others</h4>
                <p>Do not authorize gifts to other people or organizations</p>
              </div>
            </label>
          </div>

          <div className="gift-option">
            <label className="gift-label">
              <input
                type="radio"
                name="gifts-to-others"
                value="anyone"
                checked={giftsToOthers === 'anyone'}
                onChange={(e) => setGiftsToOthers(e.target.value)}
              />
              <div className="gift-content">
                <h4>Yes, to Anyone</h4>
                <p>Allow gifts to any person or organization my agent chooses</p>
              </div>
            </label>
          </div>

          <div className="gift-option">
            <label className="gift-label">
              <input
                type="radio"
                name="gifts-to-others"
                value="named_only"
                checked={giftsToOthers === 'named_only'}
                onChange={(e) => setGiftsToOthers(e.target.value)}
              />
              <div className="gift-content">
                <h4>Yes, But Only to People and Organizations I Name</h4>
                <p>Restrict gifts to specific individuals and organizations I identify</p>
              </div>
            </label>
          </div>
        </div>

        <div className="important-note">
          <h4>Important:</h4>
          <p>
            Gift authorizations can have significant tax and legal consequences. 
            Consider consulting with an estate planning attorney about gift strategies 
            and annual exclusion limits.
          </p>
        </div>
      </div>

      <ButtonBar 
        handlePrimary={handleNext}
        primaryText="Continue"
      />
    </div>
  );
}
